module.exports = __webpack_public_path__ + "static/TlwgTypewriter-049706803ce49451a51424db09ab6c24.woff";